/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QualitySectionConfig } from '../../models/quality-section-config';
import { QualitySectionConfigDto } from '../../models/quality-section-config-dto';

export interface UpdateQualitySectionConfig$Params {
  qualitySectionConfigId: string;
  body: QualitySectionConfigDto;
}

export function updateQualitySectionConfig(
  http: HttpClient,
  rootUrl: string,
  params: UpdateQualitySectionConfig$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<QualitySectionConfig>> {
  const rb = new RequestBuilder(rootUrl, updateQualitySectionConfig.PATH, 'put');
  if (params) {
    rb.path('qualitySectionConfigId', params.qualitySectionConfigId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QualitySectionConfig>;
    })
  );
}

updateQualitySectionConfig.PATH = '/admin/quality-section-config/{qualitySectionConfigId}';
